module.exports = __webpack_public_path__ + "img/grplogo.38d8b60e.png";